// extracted by mini-css-extract-plugin
export default {"row":"Se_TA","value":"I6YD2"};